import ToolbarShare from 'components/ToolbarShare';
import { DETAIL_MODAL } from 'lib/constants';
import { CruiseCardToolbarShareProps } from './CruiseCardToolbarShare.types';

function CruiseCardToolbarShare({
	position = 'bottom',
	positionMobile = 'bottom_end',
	shareUrl,
	type = DETAIL_MODAL,
	trackingEvent,
}: Readonly<CruiseCardToolbarShareProps>) {
	return (
		// PENDING: We need to migrate this to use MUI icon buttons
		<ToolbarShare shareUrl={shareUrl} positionMobile={positionMobile} position={position} type={type} trackingEvent={trackingEvent} />
	);
}

export default CruiseCardToolbarShare;
